import {
  WhitelabelDnsCheckOutcome,
  type WhitelabelDnsRecordCheck as GQLItem,
} from '../../../generated/internal.graphql';
import { take } from '../../../util/takePayload';
import type { DnsRecordPurpose } from './ExpectedDnsHost';

/** Keyed off the generated enum, so a backend rename is a compile error, not a dead comparison. */
export const DnsCheckOutcome = Object.freeze({
  CORRECT: WhitelabelDnsCheckOutcome.Correct,
  WRONG: WhitelabelDnsCheckOutcome.Wrong,
  MISSING: WhitelabelDnsCheckOutcome.Missing,
  PROXIED: WhitelabelDnsCheckOutcome.Proxied,
  COULD_NOT_CHECK: WhitelabelDnsCheckOutcome.CouldNotCheck,
});
export type DnsCheckOutcome = (typeof DnsCheckOutcome)[keyof typeof DnsCheckOutcome];

/** One expected DNS record checked against the client's DNS; `actual` is set when wrong or proxied, `error` when not checked. */
export type DnsRecordCheck = {
  role: string;
  name: string;
  type: string;
  purpose: DnsRecordPurpose;
  expectedTarget: string;
  outcome: DnsCheckOutcome;
  actual?: string;
  error?: string;
};

export const fromGql = (item: GQLItem): DnsRecordCheck => ({
  ...take<DnsRecordCheck>(item, 'role', 'name', 'type', 'purpose', 'expectedTarget', 'outcome'),
  actual: item.actual ?? undefined,
  error: item.error ?? undefined,
});

export const fromGqlCollection = (items: GQLItem[]): DnsRecordCheck[] => items.map(fromGql);
